import { writable, derived } from 'svelte/store'
import type { Driftsmelding } from '$lib/types/driftsmelding'

type Toast = {
  id: string
  message: object
  dismissible: boolean
  dismissed: boolean
  language: string
}

const defaultToast = {
  dismissible: true,
  dismissed: false,
}
function createToasts() {
  const { subscribe, set, update } = writable(<Toast>[])

  function dismissToast(id) {
    toasts.update((all) => all.map((t) => (t.id === id ? { ...t, dismissed: true } : t)))
  }

  // function addToast(toast: Toast) {
  //   const id = Math.floor(Math.random() * 10000)
  //
  //   update((currentToasts) => {
  //     if (!currentToasts.some((t) => t.message[0]._key === toast.message[0]._key)) {
  //       return [...currentToasts, { ...defaultToast, ...toast, id }]
  //     }
  //     return currentToasts
  //   })
  // }

  function updateToast(toast: Toast) {
    toasts.update((all) => all.map((t) => (t.id === toast.id ? toast : t)))
  }

  return {
    subscribe,
    set,
    update,
    dismissToast,
    updateToast,
  }
}

export const toasts = createToasts()

export const undismissedToasts = derived(toasts, (toasts) => toasts.filter((t) => !t.dismissed))

export function parseSanityDriftsmeldingToToast(driftsmelding: Driftsmelding, language: string): Toast {
  if (driftsmelding.body && driftsmelding.body[0]) {
    // const id = Math.floor(Math.random() * 10000)
    const id = driftsmelding.body[0]._key

    // const toast = { ...defaultToast, id: id, message: driftsmelding.body[0].children[0].text, language: language }
    const toast = { ...defaultToast, id: id, message: driftsmelding.body, language: language }
    return toast
  } else {
    return undefined
  }
}
